// @flow
import React, {PureComponent} from 'react';
import {Image, ScrollView, StyleSheet, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {BulletPoint, Text} from 'trpc-react-native-ui';
import {FullButton} from '../../components/common';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import * as Navigation from '../../lib/navigation.js';

export default class LineTermination extends PureComponent<Props> {
  goToPickLineToTerminate = () => Navigation.navigate('pickLineToTerminate');

  render() {
    const styles = getStyles();

    if (!this.props.hasVisibleSubscriptions) {
      return (
        <View style={styles.emptyContainer}>
          <Image source={theme.terminationImage} style={styles.image} />
          <Text style={styles.emptyText}>
            {I18n.t('Dashboard.LineTermination.noLineToTerminate')}
          </Text>
        </View>
      );
    }

    return (
      <SafeAreaView style={styles.safeareaview}>
        <View style={styles.pageContainer}>
          <ScrollView contentContainerStyle={styles.contentContainer}>
            <Image source={theme.terminationImage} style={styles.image} />
            <Text style={styles.pleaseNoteThat}>
              {I18n.t('Dashboard.LineTermination.pleaseNoteThat')}
            </Text>
            <BulletPoint
              bulletPointStyle={styles.bulletPointStyle}
              text={I18n.t('Dashboard.LineTermination.lineTerminationIsFinal')}
              textStyle={styles.bulletPointTextStyle}
              containerStyle={styles.bulletPointContainerStyle}
            />
          </ScrollView>
          <View style={styles.bottomPanel}>
            <FullButton
              text={I18n.t('Dashboard.LineTermination.pickLine')}
              onPress={this.goToPickLineToTerminate}
            />
          </View>
        </View>
      </SafeAreaView>
    );
  }
}

type Props = StateProps;

export type StateProps = {
  hasVisibleSubscriptions: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    safeareaview: {
      flex: 1,
      backgroundColor: 'transparent',
    },
    bulletPointContainerStyle: {
      alignItems: 'flex-start',
      paddingRight: 15,
      paddingLeft: 5,
    },
    bulletPointStyle: {
      color: theme.defaultTextColor,
      fontSize: 12,
      marginTop: 8,
    },
    bottomPanel: {
      paddingVertical: 13,
      paddingHorizontal: 20,
      justifyContent: 'center',
      borderTopWidth: 1,
      borderTopColor: theme.bottomPanelBorderColor,
    },
    contentContainer: {
      alignItems: 'center',
      margin: 15,
      paddingHorizontal: 10,
    },
    emptyContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    emptyText: {
      textAlign: 'center',
      color: theme.emptyTextColor,
      fontSize: 16,
    },
    image: {
      width: 100,
      height: 100,
      marginTop: 40,
      marginBottom: 40,
      resizeMode: 'contain',
    },
    pageContainer: {
      flex: 1,
      justifyContent: 'space-between',
    },
    pleaseNoteThat: {
      fontSize: 22,
      textAlign: 'center',
      marginBottom: 25,
    },
    bulletPointTextStyle: {
      fontSize: 18,
    },
  });
